/* ==========================================================================
   Pflegewegweiser Header & Navigation

   - Desktop: Mega-Panels oeffnen bei mouseenter, schliessen bei mouseleave
     (mit kurzer Verzoegerung, damit der Weg vom Menuepunkt ins Panel nicht
     abreisst). Tastatur: Enter/Space oeffnet, Escape schliesst.
   - Mobile: Drawer mit zwei Ebenen.
   - Frauen/Maenner-Filter: blendet Kategorien nach data-pww-gender-item ein.
   ========================================================================== */

(function () {
  'use strict';

  var CLOSE_DELAY = 180;

  /* Luft zwischen Panelunterkante und Bildschirmrand, und die Hoehe, unter die
     das Panel auch bei sehr flachen Fenstern nicht gedrueckt wird. */
  var PANEL_LUFT = 16;
  var PANEL_MIN = 240;

  function initHeader(header) {
    if (!header || header.dataset.pwwInit === 'true') return;
    header.dataset.pwwInit = 'true';

    var navItems = Array.prototype.slice.call(header.querySelectorAll('[data-pww-nav-item]'));
    var panels = Array.prototype.slice.call(header.querySelectorAll('[data-pww-panel]'));
    var closeTimer = null;

    /* ---------------------------------------------------------------- Desktop */

    function panelFor(id) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-pww-panel') === id) return panels[i];
      }
      return null;
    }

    function closeAll() {
      navItems.forEach(function (item) {
        item.classList.remove('is-open');
        var link = item.querySelector('.pww-nav__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (panel) {
        panel.classList.remove('is-open');
      });
      header.classList.remove('is-panel-open');
    }

    /* Das Panel haengt unter dem Header und war bei flachen Fenstern unten
       abgeschnitten – man musste die Seite scrollen, um die letzten Kacheln zu
       sehen. Hier wird die Resthoehe bis zum Bildschirmrand gemessen und als
       Grenze auf den Inhalt gelegt; passt er nicht, scrollt er in sich selbst.
       Gemessen wird erst nach dem Oeffnen, weil ein geschlossenes Panel
       display: none hat und keine Position kennt. */
    function hoeheAnpassen(panel) {
      var koerper = panel && panel.querySelector('.pww-panel__body');
      if (!koerper) return;
      var oben = panel.getBoundingClientRect().top;
      var platz = window.innerHeight - oben - PANEL_LUFT;
      koerper.style.maxHeight = Math.max(platz, PANEL_MIN) + 'px';
    }

    function offenesPanel() {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].classList.contains('is-open')) return panels[i];
      }
      return null;
    }

    var hoehePruefung = null;
    function hoehePruefen() {
      if (hoehePruefung) return;
      hoehePruefung = requestAnimationFrame(function () {
        hoehePruefung = null;
        hoeheAnpassen(offenesPanel());
      });
    }

    window.addEventListener('resize', hoehePruefen);
    window.addEventListener('scroll', hoehePruefen, { passive: true });

    function open(id) {
      var panel = panelFor(id);
      if (!panel) return;
      closeAll();
      panel.classList.add('is-open');

      /* Der Header liegt mit z-index 20 in einem eigenen Stapelkontext, der
         Seiteninhalt darunter auf 500. Alles, was dort klebt – etwa die
         Filterleiste der Kategorieseite – lag damit ueber dem offenen Panel.
         Solange ein Panel offen ist, kommt der Header nach vorne. Gleiche
         Loesung wie beim mobilen Menue. */
      header.classList.add('is-panel-open');
      hoeheAnpassen(panel);
      navItems.forEach(function (item) {
        if (item.getAttribute('data-pww-nav-item') === id) {
          item.classList.add('is-open');
          var link = item.querySelector('.pww-nav__link');
          if (link) link.setAttribute('aria-expanded', 'true');
        }
      });
    }

    function cancelClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function scheduleClose() {
      cancelClose();
      closeTimer = setTimeout(closeAll, CLOSE_DELAY);
    }

    navItems.forEach(function (item) {
      var id = item.getAttribute('data-pww-nav-item');

      item.addEventListener('mouseenter', function () {
        cancelClose();
        open(id);
      });

      item.addEventListener('mouseleave', scheduleClose);

      var link = item.querySelector('.pww-nav__link');
      if (!link) return;

      /* Klick auf das Aufklappzeichen schaltet das Panel um statt der Seite zu
         folgen – der Text daneben bleibt ein normaler Link.

         Die Sperre ist noetig, weil der Zeiger nach dem Zuklappen noch im
         Menuepunkt steht: der mouseover-Wachhund unten wuerde sonst bei der
         naechsten Zeigerbewegung sofort wieder aufklappen. Sie faellt, sobald
         der Zeiger den Menuepunkt verlaesst. */
      link.addEventListener('click', function (event) {
        if (!event.target.closest || !event.target.closest('.pww-nav__chevron')) return;
        event.preventDefault();
        cancelClose();
        if (item.classList.contains('is-open')) {
          item.dataset.pwwZu = '1';
          closeAll();
        } else {
          delete item.dataset.pwwZu;
          open(id);
        }
      });

      item.addEventListener('mouseleave', function () {
        delete item.dataset.pwwZu;
      });

      link.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          if (item.classList.contains('is-open')) {
            closeAll();
          } else {
            open(id);
          }
        }
      });

      link.addEventListener('focus', function () {
        cancelClose();
        open(id);
      });
    });

    /* Menuepunkte ohne Dropdown schliessen ein offenes Panel */
    Array.prototype.slice
      .call(header.querySelectorAll('.pww-nav__item:not([data-pww-nav-item])'))
      .forEach(function (item) {
        item.addEventListener('mouseenter', closeAll);
      });

    /* mouseenter feuert nur beim Ueberschreiten der Grenze. Bleibt eine
       Bewegung aus, weil der Zeiger schon im Menuepunkt stand – etwa nach dem
       Zuklappen per Klick, nach einem Ankersprung oder wenn die Zeile unter dem
       ruhenden Zeiger neu aufgebaut wird – kam das Panel nicht mehr hoch.
       mouseover blubbert und feuert bei jeder Bewegung, damit entscheidet
       dieser Wachhund laufend neu, welches Panel offen sein soll. */
    var navListe = header.querySelector('.pww-nav__list');
    if (navListe) {
      navListe.addEventListener('mouseover', function (event) {
        var punkt = event.target.closest && event.target.closest('.pww-nav__item');
        if (!punkt) return;

        var pid = punkt.getAttribute('data-pww-nav-item');
        if (!pid) {
          closeAll();
          return;
        }
        if (punkt.dataset.pwwZu === '1') return;
        if (punkt.classList.contains('is-open')) {
          cancelClose();
          return;
        }
        cancelClose();
        open(pid);
      });
    }

    panels.forEach(function (panel) {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });

    document.addEventListener('click', function (event) {
      if (!header.contains(event.target)) closeAll();
    });

    /* ----------------------------------------------------------------- Mobile */

    var drawer = header.querySelector('[data-pww-drawer]');
    var toggle = header.querySelector('[data-pww-menu-toggle]');

    function showView(name) {
      if (!drawer) return;
      Array.prototype.slice.call(drawer.querySelectorAll('[data-pww-view]')).forEach(function (view) {
        view.classList.toggle('is-active', view.getAttribute('data-pww-view') === name);
      });
      var list = drawer.querySelector('[data-pww-view="' + name + '"] .pww-drawer__list');
      if (list) list.scrollTop = 0;
    }

    function setDrawerTop() {
      if (!drawer) return;
      drawer.style.top = Math.round(header.getBoundingClientRect().bottom) + 'px';
    }

    function closeDrawer() {
      header.classList.remove('is-menu-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.removeProperty('overflow');
      showView('root');
    }

    /* Welche Ebene passt zur Seite, auf der man steht?

       Wer ueber "Alltagshilfen" auf "Toilettenstühle" gegangen ist, will beim
       naechsten Oeffnen wieder die Unterkategorien von Alltagshilfen sehen und
       nicht erneut die Hauptliste durchtippen. Die Seite selbst weiss nichts
       vom Menuezustand – das Blaettern laedt eine neue Seite. Also wird beim
       Oeffnen nachgesehen, wo die aktuelle Adresse im Menue vorkommt. */
    /* Einmal ausrechnen, dann merken.

       Die Suche geht durch alle Ebenen und deren Links – auf dieser Seite
       ueber 350 Knoten mit Zeichenkettenvergleich. Das lief bisher bei jedem
       Oeffnen des Menues neu, obwohl sich weder die Adresse noch die Links
       waehrend der Seitensitzung aendern. Gemessen kostete das Oeffnen 22 ms;
       auf einem Handy ein Vielfaches davon, und genau das fuehlt sich beim
       Antippen zaeh an. */
    var gemerkteEbene = null;

    function passendeEbene() {
      if (gemerkteEbene !== null) return gemerkteEbene;
      if (!drawer) return 'root';
      var hier = window.location.pathname.replace(/\/$/, '');
      var treffer = 'root';

      Array.prototype.slice.call(drawer.querySelectorAll('[data-pww-view]')).some(function (view) {
        var name = view.getAttribute('data-pww-view');
        if (name === 'root') return false;

        var passt = Array.prototype.slice.call(view.querySelectorAll('a[href]')).some(function (a) {
          var ziel = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
          return ziel && ziel === hier;
        });
        if (!passt) return false;
        treffer = name;
        return true;
      });

      gemerkteEbene = treffer;
      return treffer;
    }

    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var isOpen = header.classList.toggle('is-menu-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          showView(passendeEbene());
          setDrawerTop();
          document.documentElement.style.overflow = 'hidden';
        } else {
          closeDrawer();
        }
      });

      Array.prototype.slice.call(drawer.querySelectorAll('[data-pww-open-view]')).forEach(function (button) {
        button.addEventListener('click', function () {
          showView(button.getAttribute('data-pww-open-view'));
        });
      });

      Array.prototype.slice.call(drawer.querySelectorAll('[data-pww-back]')).forEach(function (button) {
        button.addEventListener('click', function () {
          showView('root');
        });
      });

      window.addEventListener('resize', function () {
        if (header.classList.contains('is-menu-open')) setDrawerTop();
        if (window.innerWidth >= 1000 && header.classList.contains('is-menu-open')) closeDrawer();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && header.classList.contains('is-menu-open')) closeDrawer();
      });
    }

    /* ------------------------------------------- Aufklappnavigation (Chips) */

    var chipnav = header.querySelector('[data-pww-chipnav]');
    if (chipnav) {
      var viewport = chipnav.querySelector('[data-pww-chip-viewport]');
      var zurueck = chipnav.querySelector('[data-pww-chip-back]');
      var weiter = chipnav.querySelector('[data-pww-chip-more]');
      var ebenen = Array.prototype.slice.call(chipnav.querySelectorAll('[data-pww-chip-level]'));

      function aktiveEbene() {
        for (var i = 0; i < ebenen.length; i++) {
          if (!ebenen[i].hidden) return ebenen[i];
        }
        return null;
      }

      /* Weiter-Pfeil und Auslauf-Verlauf nur zeigen, wenn rechts wirklich noch
         etwas kommt. Die Klasse steuert den Verlauf im CSS. */
      function pfeilPruefen() {
        if (!viewport) return;
        var rest = viewport.scrollWidth - viewport.clientWidth - viewport.scrollLeft;
        var mehr = rest > 4;
        if (weiter) weiter.hidden = !mehr;
        chipnav.classList.toggle('is-more', mehr);
        /* Links nur verlaufen lassen, wenn dort wirklich etwas liegt – sonst
           laege ein weisser Schleier ueber dem ersten Chip. */
        chipnav.classList.toggle('is-back', viewport.scrollLeft > 4);
      }

      function ebeneZeigen(name) {
        ebenen.forEach(function (e) {
          /* Die Markierung aus dem Liquid hat ihren Zweck erfuellt: sie sorgte
             dafuer, dass die richtige Ebene schon im ersten Bild steht. Ab hier
             fuehrt das hidden-Attribut, und die dazugehoerige CSS-Regel darf
             nicht laenger greifen – sonst bliebe die oberste Ebene auch nach
             einem Klick auf den Zurueck-Pfeil verborgen. */
          e.removeAttribute('data-pww-chip-start');
          e.hidden = e.getAttribute('data-pww-chip-level') !== name;
        });
        if (zurueck) zurueck.hidden = name === 'root';
        if (viewport) viewport.scrollLeft = 0;
        pfeilPruefen();
      }

      Array.prototype.slice.call(chipnav.querySelectorAll('[data-pww-chip-open]')).forEach(function (chip) {
        chip.addEventListener('click', function () {
          ebeneZeigen(chip.getAttribute('data-pww-chip-open'));
        });
      });

      /* Der Pfeil fuehrt zur Ueberkategorie, nicht nur zur obersten Chip-Ebene.

         Vorher wechselte er ausschliesslich die Ebene: wer auf "Einlagen"
         stand und ihn druckte, sah die obersten Chips – blieb aber auf der
         Einlagen-Seite. Gemeint war der Weg hinauf zu "Inkontinenz".

         Die Ebene heisst wie das Panel in der Navigation (panel_inkontinenz),
         und an dessen Menuepunkt haengen Titel und Adresse der Ueberkategorie.
         So wird nichts doppelt gepflegt.

         Steht man bereits auf der Ueberkategorie, gibt es nichts hinaufzugehen –
         dann bleibt es beim bisherigen Verhalten und die obersten Chips
         erscheinen. */
      function elternAdresse(ebenenName) {
        if (!ebenenName || ebenenName === 'root') return null;
        var punkt = document.querySelector('[data-pww-nav-item="' + ebenenName + '"] .pww-nav__link');
        var url = punkt ? punkt.getAttribute('href') : null;
        if (!url) return null;
        var ziel = url.split('?')[0].replace(/\/$/, '');
        var hier = window.location.pathname.replace(/\/$/, '');
        return ziel === hier ? null : url;
      }

      if (zurueck) {
        zurueck.addEventListener('click', function () {
          var offen = aktiveEbene();
          var url = elternAdresse(offen ? offen.getAttribute('data-pww-chip-level') : null);
          if (url) {
            window.location.href = url;
            return;
          }
          ebeneZeigen('root');
        });
      }

      if (weiter && viewport) {
        weiter.addEventListener('click', function () {
          viewport.scrollLeft += Math.round(viewport.clientWidth * 0.7);
        });
      }

      /* Ausserhalb der Pfeil-Bedingung: die Verlaeufe muessen dem Scrollen auch
         dann folgen, wenn es keinen Weiter-Pfeil gibt. */
      if (viewport) {
        viewport.addEventListener('scroll', pfeilPruefen, { passive: true });
        window.addEventListener('resize', pfeilPruefen);
      }

      /* Steht der Nutzer auf einer Unterseite, direkt deren Ebene aufschlagen.
         Zuerst die Ebene, in der ein Chip die offene Seite markiert; sonst die
         Ebene, deren Menuepunkt selbst die offene Seite ist (Liquid markiert sie
         mit data-pww-chip-here) – so bleiben die Unterkategorien sichtbar, ohne
         dass der Menuepunkt als Chip wiederholt werden muss. */
      var aktiverChip = chipnav.querySelector('[data-pww-chip-level]:not([data-pww-chip-level="root"]) .pww-chip.is-active');
      var hierEbene = chipnav.querySelector('[data-pww-chip-level][data-pww-chip-here]');
      var startEbene = aktiverChip ? aktiverChip.closest('[data-pww-chip-level]') : hierEbene;
      if (startEbene) {
        ebeneZeigen(startEbene.getAttribute('data-pww-chip-level'));
      } else {
        pfeilPruefen();
      }
    }

    /* --------------------------------------------------- Platzhalter Suche */

    /* Das Suchfeld existiert nur einmal im DOM (damit die Live-Suche auf beiden
       Breiten laeuft), der Platzhalter unterscheidet sich aber je Breite. */
    var searchInput = header.querySelector('[data-live-search-input]');
    var phDesktop = header.getAttribute('data-pww-placeholder-desktop') || '';
    var phMobile = header.getAttribute('data-pww-placeholder-mobile') || '';

    function syncPlaceholder() {
      if (!searchInput) return;
      var wanted = window.innerWidth >= 1000 ? phDesktop : phMobile;
      if (wanted && searchInput.placeholder !== wanted) searchInput.placeholder = wanted;
    }

    if (searchInput && (phDesktop || phMobile)) {
      syncPlaceholder();
      window.addEventListener('resize', syncPlaceholder);
    }

    /* ------------------------------------- Steckengebliebene Fremd-Overlays

       Die Warenkorb-App (UpCart) legt beim Oeffnen ihrer Schublade eine
       schwarze Flaeche ueber die ganze Seite: #UpcartPopupBackDrop im
       Schatten-DOM, z-index 2147483639, pointer-events: auto. Bleibt die
       Flaeche stehen, nachdem die Schublade zurueckgefahren ist, ist alles
       abgedunkelt und kein Klick kommt mehr an – auch nicht auf die
       Suchvorschlaege, die dann sichtbar aber tot sind.

       Aufgeraeumt wird nur dieser widerspruechliche Zustand: Flaeche sichtbar,
       Schublade aber ausserhalb des Bildschirms. Ist die Schublade offen,
       bleibt alles unangetastet, damit ein Klick daneben sie weiter schliesst.
       Fehlt die App, faellt die Pruefung still aus. */
    function fremdeFlaechePruefen() {
      var host = document.getElementById('upCart');
      if (!host || !host.shadowRoot) return;
      var flaeche = host.shadowRoot.getElementById('UpcartPopupBackDrop');
      var schublade = host.shadowRoot.getElementById('CartPopup');
      if (!flaeche || !schublade) return;

      var kasten = schublade.getBoundingClientRect();
      var draussen = kasten.width === 0 || kasten.left >= window.innerWidth || kasten.right <= 0;

      if (draussen && getComputedStyle(flaeche).display !== 'none') {
        flaeche.style.display = 'none';
      } else if (!draussen) {
        /* Schublade wieder da: eigene Sperre zuruecknehmen, sonst fehlte der
           App fuer immer ihre Abdunklung. */
        flaeche.style.removeProperty('display');
      }
    }

    document.addEventListener('pointerdown', fremdeFlaechePruefen, true);
    if (searchInput) {
      searchInput.addEventListener('focus', fremdeFlaechePruefen);
      searchInput.addEventListener('input', fremdeFlaechePruefen);
    }

    /* ------------------------------------------- Header ueber Empires Abdunkler

       Empire legt beim Oeffnen der Trefferliste .site-main-dimmer ueber die
       Seite (z-index 1000). Unser Header liegt auf 20, die Liste darin auf 200 –
       damit lag die Abdunklung ueber den Vorschlaegen: sichtbar, aber grau und
       nicht anklickbar. Solange die Liste offen ist, kommt der Header darueber.

       Gehorcht wird auf Empires eigenes Attribut data-animation-state; es gibt
       kein Event dafuer, deshalb ein Beobachter. */
    var flydown = header.querySelector('[data-live-search-flydown]');
    if (flydown && window.MutationObserver) {
      var suchZustand = function () {
        var offen = flydown.getAttribute('data-animation-state') === 'open';
        header.classList.toggle('is-search-open', offen);
      };
      new MutationObserver(suchZustand).observe(flydown, {
        attributes: true,
        attributeFilter: ['data-animation-state']
      });
      suchZustand();
    }

    /* ----------------------------------------------------------- Sprachwahl */

    var localeSelect = header.querySelector('[data-pww-locale-select]');
    if (localeSelect) {
      localeSelect.addEventListener('change', function () {
        if (localeSelect.form) localeSelect.form.submit();
      });
    }

    /* ------------------------------------------------- Frauen/Maenner-Filter */

    Array.prototype.slice.call(header.querySelectorAll('[data-pww-gender-group]')).forEach(function (group) {
      var scope = group.closest('[data-pww-panel]') || group.closest('[data-pww-view]');
      if (!scope) return;

      var pills = Array.prototype.slice.call(group.querySelectorAll('[data-pww-gender]'));
      var items = Array.prototype.slice.call(scope.querySelectorAll('[data-pww-gender-item]'));
      var label = scope.querySelector('[data-pww-section-label]');

      /* Zielgruppe je Kachel:
           both     – immer sichtbar (z. B. Bettschutz)
           only_all – nur in der Ansicht "Alle" (die allgemeine Sammelkategorie)
           women/men– nur in der jeweiligen Ansicht
         So erscheint "Einlagen" nie doppelt: bei "Alle" die allgemeine Kachel,
         bei "Für Frauen" die frauenspezifische. */
      function apply(value) {
        items.forEach(function (item) {
          var itemValue = item.getAttribute('data-pww-gender-item');
          var visible =
            itemValue === 'both' ||
            (value === 'all' ? itemValue === 'only_all' : itemValue === value);
          item.hidden = !visible;
        });
      }

      /* Titel um "für Frauen" bzw. "für Männer" ergaenzen, solange der Filter
         steht. Der nackte Titel wird beim ersten Mal weggeschrieben – sonst
         waere nach zwei Wechseln "Einlagen für Frauen für Männer" daraus
         geworden. */
      function titelSetzen(zusatz) {
        items.forEach(function (item) {
          var titel = item.querySelector('.pww-cat__title, .pww-drawer__label');
          if (!titel) return;
          if (!titel.hasAttribute('data-pww-titel')) {
            titel.setAttribute('data-pww-titel', titel.textContent.trim());
          }
          var basis = titel.getAttribute('data-pww-titel');
          titel.textContent = zusatz ? basis + ' ' + zusatz : basis;
        });
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (other) {
            other.classList.remove('is-active');
          });
          pill.classList.add('is-active');
          apply(pill.getAttribute('data-pww-gender'));
          titelSetzen(pill.getAttribute('data-pww-gender-suffix'));
          if (label && pill.hasAttribute('data-pww-gender-label')) {
            label.textContent = pill.getAttribute('data-pww-gender-label');
          }
        });
      });

      var active = group.querySelector('.pww-pill.is-active');
      apply(active ? active.getAttribute('data-pww-gender') : 'all');
      titelSetzen(active ? active.getAttribute('data-pww-gender-suffix') : '');
    });
  }

  /* ------------------------------------------------ Warenkorbzahl nachziehen

     Die Zahl neben dem Warenkorb kommt beim Seitenaufbau aus Liquid. Danach
     aktualisiert Empire sie nur, wenn seine eigene Warenkorbschaltung die
     Aenderung ausgeloest hat. Die Warenkorb-App bucht aber an Empire vorbei –
     nach dem Loeschen in ihrer Schublade blieb die alte Zahl stehen, bis man
     die Seite wechselte. Nachgemessen: Warenkorb 1 Artikel, Zahl leer.

     Darum wird hier auf die Anfragen an die Warenkorb-Endpunkte gehorcht,
     unabhaengig davon, wer sie stellt, und danach der Stand aus /cart.js
     geholt. Die Aufrufe werden unveraendert durchgereicht.

     Dasselbe Verfahren nutzt pww-product.js fuer den Versandbalken. Bewusst
     nicht zusammengelegt: den Balken gibt es nur auf der Produktseite, die
     Zahl auf jeder Seite – und keine Datei soll von der anderen abhaengen. */

  var KORB_PFAD = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/i;
  var korbLaeuft = false;
  var korbNochmal = false;

  function korbSetzen(anzahl) {
    var wert = anzahl > 0 ? String(anzahl) : '';
    Array.prototype.slice.call(document.querySelectorAll('[data-header-cart-count]')).forEach(function (feld) {
      if (feld.getAttribute('data-header-cart-count') !== wert) {
        feld.setAttribute('data-header-cart-count', wert);
      }
    });
  }

  function korbHolen() {
    if (!window.fetch) return;
    /* Laeuft schon eine Abfrage, wird nur gemerkt, dass danach noch einmal
       gefragt werden muss – sonst geht bei zwei schnellen Klicks die letzte
       Aenderung verloren. */
    if (korbLaeuft) {
      korbNochmal = true;
      return;
    }
    korbLaeuft = true;

    window.fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (a) {
        return a.ok ? a.json() : null;
      })
      .then(function (korb) {
        if (korb) korbSetzen(korb.item_count || 0);
      })
      .catch(function () {
        /* Nicht erreichbar: die alte Zahl stehen lassen ist besser als sie
           faelschlich auf null zu setzen. */
      })
      .then(function () {
        korbLaeuft = false;
        if (korbNochmal) {
          korbNochmal = false;
          korbHolen();
        }
      });
  }

  /* Etwas Luft, bis der Warenkorb auf der Gegenseite wirklich geschrieben ist. */
  function korbSpaeter() {
    window.setTimeout(korbHolen, 250);
  }

  function korbBeobachten() {
    if (window.fetch) {
      var echtesFetch = window.fetch;
      window.fetch = function (eingabe, optionen) {
        var adresse = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || '';
        var treffer = KORB_PFAD.test(adresse);
        var antwort = echtesFetch.apply(this, arguments);
        if (treffer && antwort && antwort.then) antwort.then(korbSpaeter, function () {});
        return antwort;
      };
    }

    if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
      var echtesOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (verfahren, adresse) {
        if (KORB_PFAD.test(adresse || '')) {
          this.addEventListener('load', korbSpaeter);
        }
        return echtesOpen.apply(this, arguments);
      };
    }

    /* Rueckweg ueber den Zurueck-Knopf: die Seite kommt aus dem Zwischenspeicher
       des Browsers, mitsamt der Zahl von damals. */
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) korbHolen();
    });

    /* Zurueck aus einem anderen Tab – dort kann der Warenkorb sich geaendert
       haben, etwa im Checkout. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) korbHolen();
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-header]')).forEach(initHeader);
  }

  korbBeobachten();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme-Editor: Section wird neu gerendert */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();
